<template>
  <div class="cases-card">
    <div class="card-header">
      <div class="case-info">
        <div class="name-wrapper">
          <h2 class="case-title">
            {{ caseItem.caseName }}
          </h2>
          <div
            v-if="caseItem.isHasNoMatchData"
            class="no-data"
            @mouseenter="showNoDataTooltip = true"
            @mouseleave="showNoDataTooltip = false"
            @click="goToMatchingTable"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.625 1.875H4.375C4.04348 1.875 3.72554 2.0067 3.49112 2.24112C3.2567 2.47554 3.125 2.79348 3.125 3.125V16.875C3.125 17.2065 3.2567 17.5245 3.49112 17.7589C3.72554 17.9933 4.04348 18.125 4.375 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V3.125C16.875 2.79348 16.7433 2.47554 16.5089 2.24112C16.2745 2.0067 15.9565 1.875 15.625 1.875ZM10 12.5C10.1854 12.5 10.3667 12.555 10.5208 12.658C10.675 12.761 10.7952 12.9074 10.8661 13.0787C10.9371 13.25 10.9557 13.4385 10.9195 13.6204C10.8833 13.8023 10.794 13.9693 10.6629 14.1004C10.5318 14.2315 10.3648 14.3208 10.1829 14.357C10.001 14.3932 9.81254 14.3746 9.64123 14.3036C9.46993 14.2327 9.32351 14.1125 9.2205 13.9583C9.11748 13.8042 9.0625 13.6229 9.0625 13.4375C9.0625 13.1889 9.16127 12.9504 9.33709 12.7746C9.5129 12.5988 9.75136 12.5 10 12.5ZM9.375 10.625V6.25C9.375 6.08424 9.44085 5.92527 9.55806 5.80806C9.67527 5.69085 9.83424 5.625 10 5.625C10.1658 5.625 10.3247 5.69085 10.4419 5.80806C10.5592 5.92527 10.625 6.08424 10.625 6.25V10.625C10.625 10.7908 10.5592 10.9497 10.4419 11.0669C10.3247 11.1842 10.1658 11.25 10 11.25C9.83424 11.25 9.67527 11.1842 9.55806 11.0669C9.44085 10.9497 9.375 10.7908 9.375 10.625Z"
                fill="#F1105F"
              />
            </svg>
            <transition name="fade">
              <span v-if="showNoDataTooltip" class="tooltip">
                No data matches found
              </span>
            </transition>
          </div>
        </div>
        <div class="case-members-wrapper">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.00914 11.5468C5.01126 11.5891 5.00474 11.6314 4.98999 11.6711C4.97524 11.7109 4.95256 11.7472 4.92332 11.7779C4.89409 11.8086 4.85892 11.833 4.81995 11.8497C4.78098 11.8664 4.73903 11.8749 4.69664 11.8749H1.24976C1.1087 11.8751 0.971709 11.8276 0.861072 11.7401C0.750435 11.6525 0.672658 11.5302 0.640389 11.3928C0.620296 11.2988 0.621223 11.2016 0.643102 11.108C0.664981 11.0144 0.707273 10.9268 0.766952 10.8514C1.31837 10.1202 2.04999 9.5444 2.89039 9.18034C2.52143 8.84394 2.23844 8.42402 2.06514 7.95576C1.89183 7.4875 1.83325 6.98453 1.89431 6.48898C1.95536 5.99342 2.13427 5.51971 2.41604 5.10752C2.69782 4.69532 3.07427 4.35665 3.51385 4.11986C3.95343 3.88307 4.44335 3.75506 4.94258 3.74655C5.44181 3.73804 5.93581 3.84927 6.38321 4.07094C6.83061 4.29261 7.21838 4.61825 7.51405 5.0206C7.80971 5.42295 8.00467 5.89028 8.08258 6.38347C8.09264 6.44979 8.08076 6.51758 8.04874 6.57653C8.01673 6.63548 7.96634 6.68236 7.90523 6.71003C7.03835 7.11079 6.30419 7.75116 5.78938 8.55556C5.27457 9.35996 5.00059 10.2948 4.99976 11.2499C4.99976 11.3499 4.99976 11.4483 5.00914 11.5468ZM19.2279 10.8507C18.6778 10.1202 17.9478 9.54478 17.1091 9.18034C17.4781 8.84394 17.7611 8.42402 17.9344 7.95576C18.1077 7.4875 18.1663 6.98453 18.1052 6.48898C18.0442 5.99342 17.8653 5.51971 17.5835 5.10752C17.3017 4.69532 16.9253 4.35665 16.4857 4.11986C16.0461 3.88307 15.5562 3.75506 15.0569 3.74655C14.5577 3.73804 14.0637 3.84927 13.6163 4.07094C13.1689 4.29261 12.7811 4.61825 12.4855 5.0206C12.1898 5.42295 11.9949 5.89028 11.917 6.38347C11.9069 6.44979 11.9188 6.51758 11.9508 6.57653C11.9828 6.63548 12.0332 6.68236 12.0943 6.71003C12.9612 7.11079 13.6953 7.75116 14.2102 8.55556C14.725 9.35996 14.9989 10.2948 14.9998 11.2499C14.9998 11.3499 14.9998 11.4483 14.9904 11.5468C14.9883 11.5891 14.9948 11.6314 15.0095 11.6711C15.0243 11.7109 15.047 11.7472 15.0762 11.7779C15.1054 11.8086 15.1406 11.833 15.1796 11.8497C15.2185 11.8664 15.2605 11.8749 15.3029 11.8749H18.7498C18.8908 11.8751 19.0278 11.8276 19.1385 11.7401C19.2491 11.6525 19.3269 11.5302 19.3591 11.3928C19.3794 11.2987 19.3784 11.2012 19.3564 11.1074C19.3344 11.0137 19.2918 10.926 19.2318 10.8507H19.2279ZM12.2748 14.2241C12.8971 13.7475 13.3544 13.0879 13.5824 12.338C13.8105 11.588 13.7978 10.7855 13.5462 10.0431C13.2946 9.30079 12.8167 8.65594 12.1797 8.19922C11.5427 7.74251 10.7785 7.49689 9.99469 7.49689C9.21085 7.49689 8.44672 7.74251 7.80968 8.19922C7.17265 8.65594 6.69475 9.30079 6.44314 10.0431C6.19153 10.7855 6.17886 11.588 6.40692 12.338C6.63498 13.0879 7.0923 13.7475 7.71461 14.2241C6.61034 14.7026 5.68825 15.522 5.08336 16.5624C5.0285 16.6574 4.99962 16.7652 4.99962 16.8749C4.99963 16.9846 5.02852 17.0924 5.08339 17.1874C5.13827 17.2825 5.21718 17.3613 5.31221 17.4162C5.40725 17.471 5.51504 17.4999 5.62476 17.4999H14.3748C14.4845 17.4999 14.5923 17.471 14.6873 17.4162C14.7823 17.3613 14.8613 17.2825 14.9161 17.1874C14.971 17.0924 14.9999 16.9846 14.9999 16.8749C14.9999 16.7652 14.971 16.6574 14.9162 16.5624C14.31 15.5213 13.3862 14.7018 12.2802 14.2241H12.2748Z"
              fill="#696F79"
            />
          </svg>
          <span class="user-members-count">
            {{ caseItem.membersAmount + " " + (caseItem.membersAmount === 1 ? "member" : "members") }}
          </span>
        </div>
      </div>
      <div class="case-info-right-side">
        <div class="case-settings">
          <div
            id="case_settings"
            class="user-settings"
          >
            <CaseDropdown
              :case-id-prop="'' + caseItem.id"
              :has-left-offset="true"
              :case-name="this.caseItem.caseName"
              @caseDeleted="$emit('caseDeleted')"
              @setCreds="setCaseCredentials()"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0671 7.3335C9.46706 7.3335 7.40039 9.40016 7.40039 12.0002C7.40039 14.6002 9.46706 16.6668 12.0671 16.6668C14.6671 16.6668 16.7337 14.6002 16.7337 12.0002C16.7337 9.40016 14.6671 7.3335 12.0671 7.3335ZM12.0671 15.3335C10.2004 15.3335 8.73372 13.8668 8.73372 12.0002C8.73372 10.1335 10.2004 8.66683 12.0671 8.66683C13.9337 8.66683 15.4004 10.1335 15.4004 12.0002C15.4004 13.8668 13.9337 15.3335 12.0671 15.3335Z"
                  fill="#696F79"
                />
                <path
                  d="M21.8663 9.80016L19.9997 9.20016L19.5997 8.20016L20.533 6.46683C20.733 6.06683 20.6663 5.5335 20.333 5.20016L18.733 3.60016C18.3997 3.26683 17.8663 3.20016 17.4663 3.40016L15.733 4.3335L14.733 3.9335L14.133 2.06683C13.9997 1.66683 13.5997 1.3335 13.133 1.3335H10.8663C10.3997 1.3335 9.99967 1.66683 9.93301 2.1335L9.33301 4.00016C8.93301 4.06683 8.59967 4.20016 8.26634 4.40016L6.53301 3.46683C6.13301 3.26683 5.59967 3.3335 5.26634 3.66683L3.66634 5.26683C3.33301 5.60016 3.26634 6.1335 3.46634 6.5335L4.33301 8.20016C4.19967 8.53349 4.06634 8.93349 3.93301 9.26683L2.06634 9.86683C1.66634 10.0002 1.33301 10.4002 1.33301 10.8668V13.1335C1.33301 13.6002 1.66634 14.0002 2.13301 14.1335L3.99967 14.7335L4.39967 15.7335L3.46634 17.4668C3.26634 17.8668 3.33301 18.4002 3.66634 18.7335L5.26634 20.3335C5.59967 20.6668 6.13301 20.7335 6.53301 20.5335L8.26634 19.6002L9.26634 20.0002L9.86634 21.9335C9.99967 22.3335 10.3997 22.6668 10.8663 22.6668H13.133C13.5997 22.6668 13.9997 22.3335 14.133 21.9335L14.733 20.0002L15.733 19.6002L17.4663 20.5335C17.8663 20.7335 18.3997 20.6668 18.733 20.3335L20.333 18.7335C20.6663 18.4002 20.733 17.8668 20.533 17.4668L19.5997 15.7335L19.9997 14.7335L21.933 14.1335C22.333 14.0002 22.6663 13.6002 22.6663 13.1335V10.8668C22.6663 10.4002 22.333 9.93349 21.8663 9.80016ZM21.333 12.9335L18.933 13.6668L18.8663 14.0002L18.2663 15.4002L18.0663 15.7335L19.2663 17.9335L17.933 19.2668L15.733 18.0668L15.3997 18.2668C14.933 18.5335 14.4663 18.7335 13.9997 18.8668L13.6663 18.9335L12.933 21.3335H11.0663L10.333 18.9335L9.99967 18.8668L8.59967 18.2668L8.26634 18.0668L6.06634 19.2668L4.73301 17.9335L5.93301 15.7335L5.73301 15.4002C5.46634 14.9335 5.26634 14.4668 5.13301 14.0002L5.06634 13.6668L2.66634 12.9335V11.0668L4.93301 10.4002L5.06634 10.0668C5.19967 9.53349 5.39967 9.06683 5.66634 8.60016L5.86634 8.26683L4.73301 6.06683L6.06634 4.7335L8.19967 5.9335L8.53301 5.7335C8.99967 5.46683 9.46634 5.26683 9.99967 5.1335L10.333 5.00016L11.0663 2.66683H12.933L13.6663 5.00016L13.9997 5.1335C14.4663 5.26683 14.933 5.46683 15.3997 5.7335L15.733 5.9335L17.933 4.7335L19.2663 6.06683L18.0663 8.26683L18.2663 8.60016C18.533 9.06683 18.733 9.53349 18.8663 10.0002L18.933 10.3335L21.333 11.0668V12.9335Z"
                  fill="#696F79"
                />
              </svg>
            </CaseDropdown>
          </div>
        </div>
        <div class="case-region-wrapper">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 1.25C8.17727 1.25207 6.42979 1.97706 5.14092 3.26592C3.85206 4.55479 3.12707 6.30227 3.125 8.125C3.125 14.0078 9.375 18.4508 9.64141 18.6367C9.74649 18.7103 9.87169 18.7498 10 18.7498C10.1283 18.7498 10.2535 18.7103 10.3586 18.6367C10.625 18.4508 16.875 14.0078 16.875 8.125C16.8729 6.30227 16.1479 4.55479 14.8591 3.26592C13.5702 1.97706 11.8227 1.25207 10 1.25ZM10 5.625C10.4945 5.625 10.9778 5.77162 11.3889 6.04633C11.8 6.32103 12.1205 6.71148 12.3097 7.16829C12.4989 7.62511 12.5484 8.12777 12.452 8.61273C12.3555 9.09768 12.1174 9.54314 11.7678 9.89277C11.4181 10.2424 10.9727 10.4805 10.4877 10.577C10.0028 10.6734 9.50011 10.6239 9.04329 10.4347C8.58648 10.2455 8.19603 9.92505 7.92133 9.51393C7.64662 9.1028 7.5 8.61945 7.5 8.125C7.5 7.46196 7.76339 6.82607 8.23223 6.35723C8.70107 5.88839 9.33696 5.625 10 5.625Z"
              fill="#696F79"
            />
          </svg>
          <span>{{ getCaseRegionName(caseItem.caseRegion) }}</span>
        </div>
      </div>
    </div>
    <div class="card-main">
      <div
        :class="caseItem.caseManagerRoles.length > 2 ? 'case-user-block-wrap': ''"
        class="case-user-block"
      >
        <div class="user-data">
          <div class="user-photo">
            <img
              v-if="caseItem.caseManagerAvatar"
              :src="caseItem.caseManagerAvatar"
              onerror="this.src='https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png';"
              alt="avatar"
            >
            <img
              v-else
              src="https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png"
              alt=""
            >
          </div>
          <span
            id="goto_case_details"
            class="user-name"
            @click="$router.push({ name: 'case-details', params: { slug: caseItem.id} })"
          >{{
            caseItem.caseManagerName.split(/\s+/).map(word => word[0].toUpperCase() + word.substring(1)).join(' ')
          }}</span>
        </div>

        <div
          class="span-roles-wrap"
        >
          <span
            v-for="role in caseItem.caseManagerRoles"
            :key="role"
          >
            {{ getRoleNameFE(role) }}
          </span>
        </div>
      </div>
    </div>
    <div class="case-card-wrap">
      <router-link
        v-if="caseItem.hasViewPermission"
        id="goto_case_details_link"
        :to="{name: 'case-details', params: { slug: caseItem.id}}"
        tag="a"
      >
        <span class="btn case-card-btn" @click="setCaseCredentials">View case</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import capitalizeFirstLetter from '@/mixins/capitalizeFirstLetter';
import CaseDropdown from '@/components/cases/case-buttons/CaseDropdown';
import getRoleName from '@/mixins/getRoleName';

export default {
  name: 'CaseCard',
  components: {CaseDropdown},
  mixins: [capitalizeFirstLetter, getRoleName],
  props: {
    caseItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showNoDataTooltip: false,
    };
  },
  methods: {
    setCaseCredentials() {
      localStorage.setItem('title', this.caseItem.caseName);
      localStorage.setItem('casePage', this.$route.query.page || '1');
    },
    getCaseRegionName(caseRegion) {
      if (caseRegion.startsWith('eu')) {
        return 'Europe';
      } else if (caseRegion.startsWith('us')) {
        return 'America';
      } else if (caseRegion.startsWith('ap')) {
        return 'Asia';
      } else {
        return this.capitalizeFirstLetter(caseRegion);
      }
    },
    goToMatchingTable() {
      localStorage.setItem('title', this.caseItem.caseName);
      this.$router.push({path: `cases/${this.caseItem.id}/matching`});
    }
  },
};
</script>

<style scoped lang="scss">
.cases-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 365px;
  min-height: 257px;
  padding: 25px 25px 40px;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(5, 51, 48, 0.06);
  margin: 0 15px 20px 0;
  transition: .5s all;
}

.cases-card a {
  text-decoration: none;
}

.cases-card:hover {
  background-color: var(--case-card-hover-bg);
  box-shadow: 0 4px 39px rgba(0, 0, 0, 0.08);
}

.cases-card.case-hold {
  opacity: .5;
  cursor: default;
}

.case-info {
  max-width: 141px;

  .name-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;

    .no-data {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      .tooltip {
        all: unset;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none;
        background-color: rgba(0, 0, 0, 0.75);
        color: #fff;
        z-index: 100;
        padding: 5px 10px;
        border-radius: 4px;
        font-size: 12px;
        transform: translate(-40%, -130%);
        white-space: nowrap;

        &:before {
          left: 70px;
        }
      }
    }
  }
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.case-title {
  font-size: 16px;
  font-weight: 700;
  margin: 10px 0 8px;
  line-height: 19px;
  color: var(--black-color);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.case-members-wrapper {
  display: flex;
  gap: 5px;
  margin-top: 10px;
}

.user-members-count {
  display: block;
  font-size: 12px;
  line-height: 19px;
  font-weight: 500;
  color: var(--secondary-text-color);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.case-info-right-side {
  display: flex;
  flex-direction: column;
}

.case-settings {
  display: flex;
  justify-content: flex-end;
}

.case-region-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}

.case-region-wrapper svg {
  margin-right: 5px;
}

.case-region-wrapper span {
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
  color: var(--secondary-text-color);
}

.user-notifications svg path {
  transition: .5s all;
}

.user-notifications:hover svg path {
  fill: #BDC4D0;
}

.user-notifications svg {
  max-width: 100%;
  min-height: 100%;
}

.user-settings {
  width: 24px;
  height: 24px;
}

.user-settings::v-deep .dropdown-more {
  padding: 0;
  border: unset;
}

.cases-card:hover::v-deep .dropdown-more {
  background-color: var(--case-card-hover-bg);
}

.user-settings svg path {
  transition: .5s all;
}

.user-settings:hover svg path {
  fill: var(--accent-color);
}

.user-settings svg {
  max-width: 100%;
  min-height: 100%;
}

.user-settings svg path {
  fill: #DDE3E3;
}

.card-main {
  margin: 33px 0 0 0;
  display: flex;
}

.user-data {
  max-width: 173px;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.case-user-block {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.user-photo {
  min-width: 30px;
  width: 30px;
  height: 30px;
}

.user-photo img,
.user-photo svg {
  max-width: 100%;
  max-height: 100%;
}

.user-name {
  padding: 0 0 0 10px;
  font-size: 14px;
  font-weight: 500;
  color: var(--secondary-text-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 30px);
}

.span-roles-wrap {
  display: inline-block;
  min-width: 135px;
  padding: 10px 0;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 500;
  text-align: right;
  color: var(--secondary-text-color);
}

.case-card-wrap {
  margin: 14px 0 0 0;
}

.case-card-btn {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  background-color: var(--white-color);
  color: var(--accent-color);
  border: 1px solid var(--accent-color);
  margin: 0 auto;
  max-width: 300px;
}

.case-card-btn:hover {
  background-color: var(--accent-color);
  color: var(--white-color);
}

.user-photo img {
  width: 35px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
  height: 35px;
}

</style>
